import { render } from "./CustomCheckbox.vue?vue&type=template&id=216233ae&scoped=true&lang=pug"
import script from "./CustomCheckbox.vue?vue&type=script&lang=js"
export * from "./CustomCheckbox.vue?vue&type=script&lang=js"

import "./CustomCheckbox.vue?vue&type=style&index=0&id=216233ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216233ae"]])

export default __exports__